import { motion } from 'framer-motion';
import { MapPin, Mountain, Coffee, ShoppingBag, Utensils } from 'lucide-react';

export default function LocalArea() {
  return (
    <div className="min-h-screen bg-ff-blue pt-20" data-testid="local-area-page">
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <span className="badge mb-4">Event Details</span>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl text-ff-brown">
              Local Area
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-8 mb-8">
              <div className="flex items-center gap-4 mb-6">
                <MapPin className="w-8 h-8 text-ff-brown" />
                <h2 className="font-display text-2xl text-ff-brown">Location Overview</h2>
              </div>
              <p className="text-ff-brown/70">
                Frequency Forest is held at Maitland Showgrounds in NSW, offering excellent facilities
                and a beautiful setting for our festival. The venue provides easy access while still
                maintaining that special festival atmosphere we all love.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-6">
                <Mountain className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">Natural Setting</h3>
                <p className="text-ff-brown/60 text-sm">
                  Surrounded by beautiful NSW countryside with stunning views, the site offers a unique 
                  connection to nature that makes our festival truly special.
                </p>
              </div>
              
              <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-6">
                <Coffee className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">Nearby Towns</h3>
                <p className="text-ff-brown/60 text-sm">
                  Maitland township is nearby, offering cafes, supermarkets, and fuel stations 
                  for any last-minute supplies before you arrive.
                </p>
              </div>
              
              <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-6">
                <ShoppingBag className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">Supplies</h3>
                <p className="text-ff-brown/60 text-sm">
                  We recommend stocking up before you arrive. Supermarkets and convenience stores 
                  are available in Maitland, just a short drive from the venue.
                </p>
              </div>
              
              <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-6">
                <Utensils className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">On-Site Food</h3>
                <p className="text-ff-brown/60 text-sm">
                  Don't worry if you forget something! We have a variety of food vendors 
                  and a well-stocked bar operating throughout the festival.
                </p>
              </div>
            </div>

            <div className="bg-ff-green/50 rounded-3xl p-8 mt-8">
              <h2 className="font-display text-2xl text-ff-brown mb-4">Important Notes</h2>
              <ul className="text-ff-brown/70 space-y-2">
                <li>• Mobile phone reception is generally good at the venue</li>
                <li>• ATMs are not available on site – the festival is cashless</li>
                <li>• Medical facilities are available at the venue</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
